import { c as _c } from "react/compiler-runtime";
import IconMoreAction from '@/components/assets/icon_more_action.svg';
import IconReport from '@/components/assets/icon_report.svg';
import PopoverMenu from '@/components/PopoverMenu';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import ViverseButton, { type ViverseButtonProps } from '@/components/ViverseButton';
import { useAuthContext } from '@/context/AuthContext';
import { useCheckEnterRoomContext } from '@/context/CheckEnterRoomContext';
import { useConfigsContext } from '@/context/ConfigsContext';
import { cn } from '@/lib/utils';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
type WorldMoreActionButtonProps = {
  className?: string;
  handleReport: () => void;
  iconClassName?: string;
  size?: ViverseButtonProps['size'];
};
const WorldMoreActionButton = t0 => {
  const $ = _c(26);
  const {
    className,
    handleReport,
    iconClassName,
    size
  } = t0;
  const t = useTranslations();
  const [open, setOpen] = useState(false);
  const {
    store
  } = useConfigsContext();
  const {
    isSignedIn
  } = useAuthContext();
  const {
    canPreview,
    isOwner,
    isCoOwner,
    roomData: t1
  } = useCheckEnterRoomContext();
  const {
    id: roomId
  } = t1;
  const htcAuthKey = store?.credentials?.htcToken;
  const canReport = isSignedIn && !isOwner && !isCoOwner && !!htcAuthKey && !!roomId && !canPreview;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <IconReport className="size-4" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== t) {
    t3 = t("world-more-action.report");
    $[1] = t;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== handleReport) {
    t4 = () => {
      handleReport();
      setOpen(false);
    };
    $[3] = handleReport;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== canReport || $[6] !== t3 || $[7] !== t4) {
    t5 = [{
      key: "report",
      visible: canReport,
      icon: t2,
      label: t3,
      onClick: t4
    }].filter(_temp);
    $[5] = canReport;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const menuItems = t5;
  if (menuItems.length === 0) {
    return null;
  }
  let t6;
  if ($[9] !== className) {
    t6 = cn("group flex min-w-fit gap-2 p-2", className);
    $[9] = className;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = open && "fill-vive-brand-50 hover:fill-vive-brand-50";
  let t8;
  if ($[11] !== iconClassName || $[12] !== t7) {
    t8 = cn("fill-vive-primary-20 group-hover:fill-vive-brand-50 active:fill-vive-brand-50 size-[18px]", t7, iconClassName);
    $[11] = iconClassName;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t8) {
    t9 = <IconMoreAction className={t8} />;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== size || $[17] !== t6 || $[18] !== t9) {
    t10 = <PopoverTrigger asChild={true}><ViverseButton className={t6} variant="filter" size={size}>{t9}</ViverseButton></PopoverTrigger>;
    $[16] = size;
    $[17] = t6;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== menuItems) {
    t11 = <PopoverContent side="bottom" align="end" className="mt-2 border-none bg-transparent p-0"><PopoverMenu className="bg-vive-primary-70 rounded-[3px] p-2"><PopoverMenu.Group>{menuItems.map(_temp2)}</PopoverMenu.Group></PopoverMenu></PopoverContent>;
    $[20] = menuItems;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== open || $[23] !== t10 || $[24] !== t11) {
    t12 = <Popover open={open} onOpenChange={setOpen}>{t10}{t11}</Popover>;
    $[22] = open;
    $[23] = t10;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  return t12;
};
export default WorldMoreActionButton;
function _temp(item) {
  return item.visible;
}
function _temp2(item_0) {
  return <PopoverMenu.Item key={item_0.key} className="rounded-none" onClick={item_0.onClick}>{item_0.icon}<div className="body-1 text-vive-primary-20">{item_0.label}</div></PopoverMenu.Item>;
}